(function () {
  'use strict';

  angular.module('lead.status', ['ngResource']);
})();
